<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>Vendor Name <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-select
        id="txtVendorId"
        v-model="clientExcursionManagementData.vendorSid"
        :items="clientExcursionManagementVendorsListView"
        item-title="name"
        item-value="sid"
        placeholder="Select Vendor Name"
        color="primary"
        persistent-placeholder
        :error-messages="vendorSidErrors"
        variant="solo"
        density="compact"
        @update:model-value="v$.clientExcursionManagementData.vendorSid.$touch()"
        @blur="v$.clientExcursionManagementData.vendorSid.$touch()"
      >
        <template #item="data">
          <v-list-item
            v-bind="data.props"
            :id="`client-individual-modal--excursion-management-vendor--vendor-name--option-${String(
              data.item.name
            ).replaceAll(' ', '')}`"
          >
            {{ data.item.name }}
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12">
      <span>Vendor Client SID <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtVendorClientSid"
        v-model="clientExcursionManagementData.vendorClientSid"
        variant="solo"
        density="compact"
        placeholder="Vendor Client SID"
        :error-messages="vendorClientSidErrors"
        @update:model-value="v$.clientExcursionManagementData.vendorClientSid.$touch()"
        @blur="v$.clientExcursionManagementData.vendorClientSid.$touch()"
        @keyup="autoPopulateVenderClientSid()"
      />
    </v-col>
    <v-col cols="12">
      <span>Vendor Client Name <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtVendorClientName"
        v-model="clientExcursionManagementData.vendorClientName"
        variant="solo"
        density="compact"
        placeholder="Vendor Client Name"
        :error-messages="vendorClientNameErrors"
        @update:model-value="v$.clientExcursionManagementData.vendorClientName.$touch()"
        @blur="v$.clientExcursionManagementData.vendorClientName.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <span>Excursion Management Vendor Webhook URL</span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="client-individual-modal--excursion-management-vendor-webhook-url--input"
        v-model="clientExcursionManagementData.excursionManagementVendorWebhookUrl"
        variant="solo"
        density="compact"
        placeholder="Excursion Management Vendor Webhook URL"
        :error-messages="excursionManagementVendorWebhookUrlErrors"
        @update:model-value="
          v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$touch()
        "
        @blur="v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <span>Excursion Management Vendor Shared Secret Key</span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="client-individual-modal--excursion-management-vendor-shared-secret-key--input"
        v-model="clientExcursionManagementData.excursionManagementVendorSharedSecretKey"
        variant="solo"
        density="compact"
        placeholder="Excursion Management Vendor Shared Secret Key"
      />
    </v-col>
    <v-col cols="12">
      <v-checkbox
        id="cbxEnableVendorExcursionInput"
        v-model="clientExcursionManagementData.vendorExcursionSidInputEnabled"
        label="Enable Vendor Excursion SID Input"
        density="compact"
        color="primary"
      />
    </v-col>
    <v-col cols="12">
      <v-checkbox
        id="boardingSupportEnabledCheckbox"
        v-model="clientExcursionManagementData.boardingSupportEnabled"
        class="client-individual-checkbox"
        label="Enable Boarding Support"
        density="compact"
        color="primary"
      />
    </v-col>
    <v-col cols="12">
      <span>School Types</span>
    </v-col>
    <v-col cols="12">
      <v-card class="pa-2" border>
        <v-row justify="space-between">
          <v-col cols="10">
            <v-text-field
              id="newSchoolType"
              v-model="newSchoolType.name"
              variant="solo"
              density="compact"
              placeholder="Eg. Junior School or Primary"
              :error-messages="newSchoolType.errorMessage"
            />
          </v-col>
          <v-col cols="1" class="mr-2">
            <cs-button id="btnAddSchoolType" small label="Add" @click="addSchoolType" />
          </v-col>
        </v-row>
        <v-row
          v-for="(school, index) in clientExcursionManagementData.schoolTypes"
          :key="index"
          justify="space-between"
        >
          <v-col cols="10">
            <v-text-field
              :id="getSchoolTypeTxtFieldId(index)"
              v-model="school.name"
              variant="solo"
              density="compact"
              placeholder="Eg. Junior School or Primary"
              :error-messages="school.errorMessage"
              validate-on="input"
              @update:model-value="changeSchoolType(school, index)"
              @change="showSchoolTypeWarning"
            />
          </v-col>
          <v-col cols="1" class="mr-2">
            <cs-button
              :id="`btnDeleteSchoolButton${index}`"
              small
              delete
              label="Delete"
              :disabled="school.errorMessage?.length > 0"
              @click="deleteSchoolType(school)"
            ></cs-button>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export function validateKebabCasedString(value) {
  const regex = /^([a-z0-9]*)([-.][a-z0-9]+)*$/;
  const kebabCasedStringValid = regex.test(value);
  return kebabCasedStringValid;
}

export function validateUrl(value) {
  if (!value || (value && value.length === 0)) {
    return true;
  }
  const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w-]+)+[\w\-_~:/?#[\]@!&',;=.]+$/;
  const urlValid = regex.test(value);
  return urlValid;
}

export default {
  name: 'ClientExcursionManagement',
  extends: CSBase,
  props: {
    clientSid: {
      type: String,
      required: false,
      default: ''
    },
    showVendorClientSidConflict: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['clientExcursionManagementChanged', 'showSchoolTypeWarning', 'isValidSchoolType'],
  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      clientExcursionManagementData: {
        vendorSid: {
          required
        },
        vendorClientName: {
          required
        },
        excursionManagementVendorWebhookUrl: {
          validateExcursionManagementVendorWebhookUrl: validateUrl
        },
        vendorClientSid: {
          required,
          validateKebabCasedString
        }
      }
    };
  },

  data() {
    return {
      editMode: {
        type: String,
        required: false,
        default: 'create'
      },
      clientExcursionManagementData: {
        vendorSid: null,
        vendorClientSid: '',
        vendorClientName: '',
        excursionManagementVendorWebhookUrl: '',
        excursionManagementVendorSharedSecretKey: '',
        vendorExcursionSidInputEnabled: false,
        boardingSupportEnabled: false,
        schoolTypes: []
      },
      excursionManagementVendors: [],
      newSchoolType: {},
      vendorClientSidConflicted: false
    };
  },

  watch: {
    clientExcursionManagementData: {
      handler() {
        this.$emit('clientExcursionManagementChanged', this.clientExcursionManagementData);
      },
      deep: true
    },
    // @TODO to allow SaveAll to show vendor client sid conflict. To be removed after consolidation
    showVendorClientSidConflict() {
      this.vendorClientSidConflicted = this.showVendorClientSidConflict;
    }
  },

  async mounted() {
    await this.$store.dispatch('clients/fetchClientExcursionManagementVendorsList');
    await this.initPage(this.clientSid);
  },

  computed: {
    ...mapGetters({
      clientExcursionManagementView: 'clients/clientExcursionManagementView',
      clientExcursionManagementVendorsListView: 'clients/clientExcursionManagementVendorsListView'
    }),
    vendorSidErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorSid.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorSid.required.$invalid) {
        errors.push('Vendor Name is required');
      }
      return errors;
    },
    vendorClientNameErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorClientName.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorClientName.required.$invalid) {
        errors.push('Vendor Client Name is required');
      }
      return errors;
    },
    excursionManagementVendorWebhookUrlErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$dirty)
        return errors;
      if (
        this.v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl
          .validateExcursionManagementVendorWebhookUrl.$invalid
      ) {
        errors.push('Invalid Excursion Management Vendor Webhook URL');
      }
      return errors;
    },
    vendorClientSidErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorClientSid.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorClientSid.required.$invalid) {
        errors.push('Vendor Client SID is required');
      } else if (
        this.v$.clientExcursionManagementData.vendorClientSid.validateKebabCasedString.$invalid
      ) {
        errors.push('Vendor Client SID must be a kebab-cased string');
      } else if (this.vendorClientSidConflicted) {
        errors.push('Vendor Client SID conflicted');
      }
      return errors;
    }
  },

  methods: {
    getSchoolTypeTxtFieldId(index) {
      return `client-individual-modal--school-type--text-input-${index}`;
    },
    autoPopulateVenderClientSid() {
      if (!this.clientExcursionManagementData.vendorClientSid && this.clientSid) {
        this.clientExcursionManagementData.vendorClientSid = this.clientSid;
      }
    },
    async initPage(clientSid) {
      if (clientSid) {
        this.editMode = 'update';
        await this.fetchExcursionManagement();
        this.reloadData();
      }
    },
    async fetchExcursionManagement() {
      try {
        if (this.clientSid) {
          this.setLoading(true);
          await this.$store.dispatch('clients/fetchClientExcursionManagement', this.clientSid);
          this.clearLoading();
        }
      } catch (e) {
        this.clearLoading();
      }
    },
    reloadData() {
      const {
        activeVendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      } = cloneDeep(this.clientExcursionManagementView);
      this.clientExcursionManagementData = {
        vendorSid: activeVendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      };
    },
    showSchoolTypeWarning() {
      if (this.clientSid) {
        this.$emit('showSchoolTypeWarning');
      }
    },
    changeSchoolType(school) {
      const trimmedSchoolName = school.name?.trim();
      if (!trimmedSchoolName) {
        school.errorMessage = ['School Name is required'];
        this.$forceUpdate();
        this.$emit('isValidSchoolType', false);
        return;
      }
      if (
        this.clientExcursionManagementData.schoolTypes?.some(
          (s) => s.name.toLowerCase() === trimmedSchoolName.toLowerCase() && s.id !== school.id
        )
      ) {
        school.errorMessage = ['School Name conflicted'];
        this.$forceUpdate();
        this.$emit('isValidSchoolType', false);
        return;
      }
      delete school.errorMessage;
      this.$emit('isValidSchoolType', true);
    },
    addSchoolType() {
      this.newSchoolType.name = this.newSchoolType.name?.trim();
      if (!this.newSchoolType.name) {
        this.newSchoolType.errorMessage = ['School Name is required'];
        return;
      }
      if (
        this.clientExcursionManagementData.schoolTypes?.some(
          (s) => s.name.toLowerCase() === this.newSchoolType.name.toLowerCase()
        )
      ) {
        this.newSchoolType.errorMessage = ['School Name conflicted'];
        return;
      }
      if (this.clientExcursionManagementData.schoolTypes?.length > 0) {
        this.newSchoolType.id =
          Math.max(...this.clientExcursionManagementData.schoolTypes.map((s) => s.id)) + 1;
      } else {
        this.newSchoolType.id = 1;
      }
      this.newSchoolType.errorMessage = [];
      this.clientExcursionManagementData.schoolTypes.push({
        id: this.newSchoolType.id,
        name: this.newSchoolType.name
      });
      this.newSchoolType = {};
      this.showSchoolTypeWarning();
    },
    deleteSchoolType(school) {
      this.clientExcursionManagementData.schoolTypes =
        this.clientExcursionManagementData.schoolTypes.filter((s) => s.id !== school.id);
      this.showSchoolTypeWarning();
    }
  }
};
</script>
